import { useCallback, useMemo } from 'react'

import { useNavigate } from 'react-router'
import { useCurrentMember, useSelectedTrial } from 'src/features/auth/context'
import { useQuery } from 'src/legacy_modules/router'

import { ICF_DOCUMENT_HOSPITAL_QUERY_PARAM_KEY } from './routes'

export const useIcfDocumentHospital = () => {
  const query = useQuery()
  const { selectedTrial } = useSelectedTrial()
  const { selectedTrialHospitalUid: currentHospitalUid } = useCurrentMember()
  const navigate = useNavigate()

  const selectedTrialHospitalUid = useMemo(() => {
    const fromQueryParam = query.get(ICF_DOCUMENT_HOSPITAL_QUERY_PARAM_KEY)
    if (fromQueryParam !== null) {
      return fromQueryParam
    }
    //複数医療機関に紐づく場合（DMなど）はnullになる
    if (currentHospitalUid !== null) {
      return currentHospitalUid
    }

    return selectedTrial.trialHospitals[0].uid
  }, [query, selectedTrial, currentHospitalUid])

  const onChangeTrialHospital = useCallback(
    (trialHospitalUid: string) => {
      navigate({
        search: `?${ICF_DOCUMENT_HOSPITAL_QUERY_PARAM_KEY}=${trialHospitalUid}`,
      })
    },
    [navigate],
  )

  return {
    selectedTrialHospitalUid,
    onChangeTrialHospital,
  }
}
